import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expenditure-grid',
  templateUrl: './expenditure-grid.component.html',
  styleUrls: ['./expenditure-grid.component.css']
})
export class ExpenditureGridComponent implements OnInit {

  title = "Expenditure List";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/finance/expenditure/expenditure-grid/expenditure-grid.component.ts